<script>
import VueHorizontal from "vue-horizontal";

export default {
  props: ["data", "addClass"],
  data() {
    return {
      hasPrev: false,
      hasNext: true,

      swiperOption: {
        speed: 1500,
        loop: true,
        // effect: 'slide',
        autoplay: {
          delay: 3000,
        },
        spaceBetween: 30,
        breakpoints: {
          1499: {
            slidesPerView: 3,
          },

          768: {
            slidesPerView: 1,
          },

          480: {
            slidesPerView: 1,
          },
        },
        navigation: {
          nextEl: ".ht-swiper-button-next",
          prevEl: ".ht-swiper-button-prev",
        },
      },
    };
  },
  components: { VueHorizontal },
  methods: {
    prev() {
      this.$refs.horizontal.prev();
    },
    next() {
      this.$refs.horizontal.next();
    },
    onScrollDebounce({ hasPrev, hasNext }) {
      this.hasPrev = hasPrev;
      this.hasNext = hasNext;
    },
  },
};
</script>
<template>
  <div
    class="brand-logo-slider-area section-space--inner--60"
    :class="addClass"
  >
    <div class="container">
      <div class="row text-left mb-5">
        <div class="col-lg-12">
          <h3 class="text-color-green font-size-24">
            <span class="span-hr-green-left"></span>TESTIMONI
          </h3>
          <h2>Apa kata mereka</h2>
          <!-- <p class="font-size-15">Testimoni dari SMA 1 Indonesia</p> -->
        </div>
      </div>
      <!-- brand logo slider -->
      <div class="content_testimonial_green">
        <div class="row">
          <div class="col-md-12">
            <div class="header">
              <h2></h2>
              <nav>
                <button
                  @click="prev"
                  :class="{ active: hasPrev, inactive: !hasPrev }"
                >
                  <svg viewBox="0 0 24 24">
                    <path
                      d="m9.8 12 5 5a1 1 0 1 1-1.4 1.4l-5.7-5.7a1 1 0 0 1 0-1.4l5.7-5.7a1 1 0 0 1 1.4 1.4l-5 5z"
                    />
                  </svg>
                </button>
                <button
                  @click="next"
                  :class="{ active: hasNext, inactive: !hasNext }"
                >
                  <svg viewBox="0 0 24 24">
                    <path
                      d="m14.3 12.1-5-5a1 1 0 0 1 1.4-1.4l5.7 5.7a1 1 0 0 1 0 1.4l-5.7 5.7a1 1 0 0 1-1.4-1.4l5-5z"
                    />
                  </svg>
                </button>
              </nav>
            </div>

            <vue-horizontal
              ref="horizontal"
              class="horizontal"
              :button="false"
              @scroll-debounce="onScrollDebounce"
            >
              <div class="card" v-for="item in data" :key="item.id">
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-4">
                      <div
                        class="image"
                        :style="{ background: `url(${item.image})` }"
                      ></div>
                    </div>
                    <div class="col-md-8">
                      <div class="content">
                        <p>"{{ item.body.substring(0, 250) }}"</p>
                        <h6>{{ item.title }}</h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </vue-horizontal>
          </div>
        </div>
      </div>
      <!-- <div class="brand-logo-slider__container-area">
        <div class="swiper-container brand-logo-slider__container">
          <div class="swiper-wrapper brand-logo-slider__wrapper">
            <swiper :options="swiperOption" v-if="data.length > 0">
              <div
                class="swiper-slide brand-logo-slider__single justify-content-center"
                v-for="item in data"
                :key="item.id"
              >
                <div class="image text-center">
                  <div class="col-sm-12">
                    <div class="row justify-content-center mb-4">
                      <div class="col-sm-12">
                        <a href="#">
                          <img
                            :src="item.image"
                            class="circular--landscape"
                            alt="brand logo"
                          />
                        </a>
                      </div>
                    </div>
                    <div class="row justify-content-center mb-3">
                      <div class="col-sm-8">
                        <p>"{{ item.body.substring(0, 150) }}"</p>
                      </div>
                    </div>
                    <div class="row justify-content-center">
                      <div class="col-sm-8">
                        <h3>{{ item.title }}</h3>
                        <p class="font-size-17 text-color-green">
                          {{ item.classOf }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </swiper>
            <swiper :options="swiperOption" v-else>
              <div
                class="swiper-slide swiper-slide-testimonial brand-logo-slider__single justify-content-center"
              >
                <div class="image text-center mt-3 mb-3">
                  <div class="col-sm-12">
                    <div class="row justify-content-center mb-4">
                      <div class="col-sm-12">
                        <a href="#">
                          <img
                            src="@/assets/images/global/list_empty.png"
                            class="circular--landscape img-fluid h-100"
                            alt="brand logo"
                          />
                        </a>
                      </div>
                    </div>
                    <div class="row justify-content-center mb-3">
                      <div class="col-sm-8">
                        <p>Data belum tersedia</p>
                      </div>
                    </div>
                    <div class="row justify-content-center">
                      <div class="col-sm-8">
                        <h3>Data belum tersedia</h3>
                        <p class="font-size-17 text-color-green">
                          Data belum tersedia
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </swiper>
            <div
              class="ht-swiper-button-prev ht-swiper-button-prev-13 ht-swiper-button-nav d-none d-xl-block"
            >
              <i class="ion-ios-arrow-left"></i>
            </div>
            <div
              class="ht-swiper-button-next ht-swiper-button-next-13 ht-swiper-button-nav d-none d-xl-block"
            >
              <i class="ion-ios-arrow-forward"></i>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>
<style lang="scss" scoped>
@import "@/assets/scss/4-sections/template_green/_testimonial_green.scss";
</style>
<style>
.testi-image {
  border-radius: 50%;
}
</style>
